import { api } from './client';
import type { JournalEntryDto, CreateJournalEntryRequest, UpdateJournalEntryRequest } from '../types/journal';

export const journalApi = {
  post: (id: number) => api.post(`/journal-entries/${id}/post`),
  list: (params: { from?: string; to?: string; q?: string; limit?: number } = {}) =>
    api.get<JournalEntryDto[]>('/journal-entries', {
      from: params.from,
      to: params.to,
      q: params.q,
      limit: params.limit ?? 50,
    }),

  getById: (id: number) =>
    api.get<JournalEntryDto>(`/journal-entries/${id}`),

  search: (q: string, limit = 50) =>
    api.get<JournalEntryDto[]>('/journal-entries/search', { q, limit }),

  create: (data: CreateJournalEntryRequest) =>
    api.post<number>('/journal-entries', data),

  update: (id: number, data: UpdateJournalEntryRequest) =>
    api.put<void>(`/journal-entries/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/journal-entries/${id}`),

  clone: (id: number, data: { newDate: string; newDocumentNumber?: string; newContent?: string; autoSerialCode?: string }) =>
    api.post<number>(`/journal-entries/${id}/clone`, data),

  bulkDelete: (ids: number[]) =>
    api.post<{ successCount: number; failureCount: number; errors: string[] }>('/journal-entries/bulk-delete', { entryIds: ids }),
};
